import React, { memo } from "react";
import classes from "./Cart.module.css";
import { catNFT } from "../../Themes/Images";

const Cart = ({ name, image }) => {
  return (
    <div className={classes.container}>
      <img src={image || catNFT} alt="cat" width='100%' height='250px' />
      <div className={classes.detailsWrapper}>
        <p className={classes.title}>{name}</p>
        <p className={classes.desc}> NFT Details</p>
      </div>
    </div>
  );
};

export default memo(Cart);
